import api from "@client/content/lib/api";
import { type ModuleApiInfo } from "@client/content/selectors";
import { type HttpApiResponse } from "@client/types/Api";
import { System } from "@common/declarations";
import { type MemberHelpdesk } from "./types";

export default {
  init: (
    apiInfo: ModuleApiInfo,
    args: MemberHelpdesk.Api.InitRequest
  ): Promise<HttpApiResponse<MemberHelpdesk.Api.InitResponse>> =>
    api.get(apiInfo, `/api/site/v1/modules/member/helpdesk`, args),
  createComment: (
    apiInfo: ModuleApiInfo,
    args: MemberHelpdesk.Api.CreateCommentRequest
  ): Promise<HttpApiResponse<MemberHelpdesk.Api.CreateCommentResponse>> =>
    api.post(apiInfo, `/api/site/v1/modules/member/helpdesk/comment`, args),
  createTicket: (
    apiInfo: ModuleApiInfo,
    args: MemberHelpdesk.Api.CreateTicketRequest
  ): Promise<HttpApiResponse<MemberHelpdesk.Api.CreateTicketResponse>> =>
    api.post(apiInfo, `/api/site/v1/modules/member/helpdesk/ticket`, args),
  detail: (
    apiInfo: ModuleApiInfo,
    args: MemberHelpdesk.Api.GetDetailRequest
  ): Promise<HttpApiResponse<MemberHelpdesk.Api.GetDetailResponse>> =>
    api.get(apiInfo, `/api/site/v1/modules/member/helpdesk/ticket/${args.ticketId}`),
  closeTicket: (
    apiInfo: ModuleApiInfo,
    args: MemberHelpdesk.Api.CloseTicketRequest
  ): Promise<HttpApiResponse<MemberHelpdesk.Api.CloseTicketResponse>> =>
    api.put(apiInfo, `/api/site/v1/modules/member/helpdesk/ticket/${args.ticketId}/close`),
  createUserFeedback: (
    apiInfo: ModuleApiInfo,
    args: MemberHelpdesk.Api.CreateUserFeedbackRequest
  ): Promise<HttpApiResponse<MemberHelpdesk.Api.CreateUserFeedbackResponse>> =>
    api.post(apiInfo, `/api/site/v1/modules/member/helpdesk/feedback`, args),
  updateUser: (apiInfo: ModuleApiInfo): Promise<HttpApiResponse<void>> =>
    api.put(apiInfo, `/api/site/v1/modules/member/helpdesk/user`),
  updateViolation: (
    apiInfo: ModuleApiInfo,
    args: MemberHelpdesk.Api.UpdateViolationRequest
  ): Promise<HttpApiResponse<MemberHelpdesk.Api.GuidelineViolation>> =>
    api.put(apiInfo, `/api/site/v1/modules/member/helpdesk/violation/${args.guidelineViolationId}`),
  getCustomFields: (
    apiInfo: ModuleApiInfo,
    departmentId?: string
  ): Promise<HttpApiResponse<System.FormFieldWithContext[]>> =>
    api.get(apiInfo, `/api/site/v1/modules/member/helpdesk/custom/`, { departmentId })
};
